import { render, staticRenderFns } from "./ProjectPageTemplate.vue?vue&type=template&id=5377d420&scoped=true&"
import script from "./ProjectPageTemplate.vue?vue&type=script&lang=js&"
export * from "./ProjectPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPageTemplate.vue?vue&type=style&index=0&id=5377d420&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5377d420",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFabTransition,VFadeTransition,VIcon,VRow,VSpacer})
